import { lazy } from 'react';
import { NewVersionAvailable } from '../components/NewVersionAvailable';

// Lazy load all pages
export const ProgressReport = lazy(() =>
  import('./ProgressReport').then((m) => ({ default: m.ProgressReport })).catch(catcher),
);
export const NpsReport = lazy(() =>
  import('./NpsReport').then((m) => ({ default: m.NpsReport })).catch(catcher),
);

// Shared error handler
const catcher = (e: Error) => {
  console.log(e);
  return { default: NewVersionAvailable };
};
